import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * project 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	projectList( params={} ) {
		return request({
	    url: baseUrl + '/project/index',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * project 添加
	**/
	projectAdd(data){
		return request({
			url: baseUrl + '/project/add',
			method:'POST',
			data
		})
	},

	/**
	 * project 编辑
	**/
	projectEdit(id,data){
		return request({
			url: baseUrl + '/project/edit/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * project 删除
	**/
	projectDel(id){
		return request({
			url: baseUrl + '/project/del/'+id,
			method:'DELETE'
		})
	}
}